import BranchItem from "./BranchItem";
import { Stack } from "@mui/material";
import FiltersChipArray from "./FiltersChipArray";
import InitSearchAlert from "../ui/InitSearchAlert";

const BranchList = ({ branches }) => {
  return (
    <Stack spacing={2}>
      <FiltersChipArray />
      {branches.length === 0 && <InitSearchAlert />}
      {branches.map((branch, i) => {
        return (
          <BranchItem
            key={i}
            name={branch.name}
            address={branch.address}
            phoneNumber={branch.phoneNumber}
            locationUrl={branch.locationUrl}
            bookAttributes={branch.bookAttributes}
            // doctors={branch.doctors}
            doctors={[]}
            imagesGalleryUrls={branch.images_gallery_urls}
            officeHours={branch.officeHours}
            position={branch.position}
          />
        );
      })}
    </Stack>
  );
};

export default BranchList;
